const appData = {
  locked: false,
  cards: {
    'card-1': {
      id: 'card-1',
      front: 'Complex',
      back: 'Simple',
      flipped: false,
      isBeingDragged: false,
    },
    'card-2': {
      id: 'card-2',
      front: 'Momentous',
      back: 'Everyday',
      flipped: false,
      isBeingDragged: false,
    },
    'card-3': {
      id: 'card-3',
      front: 'Raw',
      back: 'Refined',
      flipped: false,
      isBeingDragged: false,
    },
    'card-4': {
      id: 'card-4',
      front: 'Curious',
      back: 'Certain',
      flipped: false,
      isBeingDragged: false,
    },
    'card-5': {
      id: 'card-5',
      front: 'Welcoming',
      back: 'Reserved',
      flipped: false,
      isBeingDragged: false,
    },
    'card-6': {
      id: 'card-6',
      front: 'Humble',
      back: 'Proud',
      flipped: false,
      isBeingDragged: false,
    },
    'card-7': {
      id: 'card-7',
      front: 'Savvy',
      back: 'Scholarly',
      flipped: false,
      isBeingDragged: false,
    },
    'card-8': {
      id: 'card-8',
      front: 'Experimental',
      back: 'Conventional',
      flipped: false,
      isBeingDragged: false,
    },
    'card-9': {
      id: 'card-9',
      front: 'Modern',
      back: 'Vintage',
      flipped: false,
      isBeingDragged: false,
    },
    'card-10': {
      id: 'card-10',
      front: 'Geeky',
      back: 'Wise',
      flipped: false,
      isBeingDragged: false,
    },
    'card-11': {
      id: 'card-11',
      front: 'Relaxed',
      back: 'Disciplined',
      flipped: false,
      isBeingDragged: false,
    },
    'card-12': {
      id: 'card-12',
      front: 'Dynamic',
      back: 'Steady',
      flipped: false,
      isBeingDragged: false,
    },
    'card-13': {
      id: 'card-13',
      front: 'Basic',
      back: 'High-end',
      flipped: false,
      isBeingDragged: false,
    },
    'card-14': {
      id: 'card-14',
      front: 'Approachable',
      back: 'Exclusive',
      flipped: false,
      isBeingDragged: false,
    },
    'card-15': {
      id: 'card-15',
      front: 'Fun',
      back: 'Serious',
      flipped: false,
      isBeingDragged: false,
    },
    'card-16': {
      id: 'card-16',
      front: 'Niche',
      back: 'Mass-market',
      flipped: false,
      isBeingDragged: false,
    },
    'card-17': {
      id: 'card-17',
      front: 'Futuristic',
      back: 'Nostalgic',
      flipped: false,
      isBeingDragged: false,
    },
    'card-18': {
      id: 'card-18',
      front: 'Organic',
      back: 'Industrial',
      flipped: false,
      isBeingDragged: false,
    },
    'card-19': {
      id: 'card-19',
      front: 'Open-minded',
      back: 'Opinionated',
      flipped: false,
      isBeingDragged: false,
    },
    'card-20': {
      id: 'card-20',
      front: 'Casual',
      back: 'Formal',
      flipped: false,
      isBeingDragged: false,
    },
    'card-21': {
      id: 'card-21',
      front: 'Current',
      back: 'Timeless',
      flipped: false,
      isBeingDragged: false,
    },
    'card-22': {
      id: 'card-22',
      front: 'Cheeky',
      back: 'Respectful',
      flipped: false,
      isBeingDragged: false,
    },
    'card-23': {
      id: 'card-23',
      front: 'Progressive',
      back: 'Traditional',
      flipped: false,
      isBeingDragged: false,
    },
    'card-24': {
      id: 'card-24',
      front: 'Scientific',
      back: 'Artistic',
      flipped: false,
      isBeingDragged: false,
    },
    'card-25': {
      id: 'card-25',
      front: 'Surprising',
      back: 'Dependable',
      flipped: false,
      isBeingDragged: false,
    },
    'card-26': {
      id: 'card-26',
      front: 'Multifaceted',
      back: 'Focused',
      flipped: false,
      isBeingDragged: false,
    },
    'card-27': {
      id: 'card-27',
      front: 'Laid-back',
      back: 'Aggressive',
      flipped: false,
      isBeingDragged: false,
    },
    'card-28': {
      id: 'card-28',
      front: 'Relatable',
      back: 'Mysterious',
      flipped: false,
      isBeingDragged: false,
    },
    'card-29': {
      id: 'card-29',
      front: 'Glamorous',
      back: 'Austere',
      flipped: false,
      isBeingDragged: false,
    },
    'card-30': {
      id: 'card-30',
      front: 'Adventurous',
      back: 'Careful',
      flipped: false,
      isBeingDragged: false,
    },
    'card-31': {
      id: 'card-31',
      front: 'Imaginative',
      back: 'Practical',
      flipped: false,
      isBeingDragged: false,
    },
    'card-32': {
      id: 'card-32',
      front: 'Crafted',
      back: 'Standardized',
      flipped: false,
      isBeingDragged: false,
    },
    'card-33': {
      id: 'card-33',
      front: 'Small',
      back: 'Big',
      flipped: false,
      isBeingDragged: false,
    },
    'card-34': {
      id: 'card-34',
      front: 'Quiet',
      back: 'Bold',
      flipped: false,
      isBeingDragged: false,
    },
    'card-35': {
      id: 'card-35',
      front: 'Energetic',
      back: 'Calm',
      flipped: false,
      isBeingDragged: false,
    },
    'card-36': {
      id: 'card-36',
      front: 'Cutting-edge',
      back: 'Trusted',
      flipped: false,
      isBeingDragged: false,
    },
    'card-37': {
      id: 'card-37',
      front: 'Playful',
      back: 'Professional',
      flipped: false,
      isBeingDragged: false,
    },
    'card-38': {
      id: 'card-38',
      front: 'Ordinary',
      back: 'Best-in-class',
      flipped: false,
      isBeingDragged: false,
    },
    'card-39': {
      id: 'card-39',
      front: 'Idealistic',
      back: 'Realistic',
      flipped: false,
      isBeingDragged: false,
    },
    'card-40': {
      id: 'card-40',
      front: 'Emotional',
      back: 'Analytical',
      flipped: false,
      isBeingDragged: false,
    },
    'card-41': {
      id: 'card-41',
      front: 'Radical',
      back: 'Rational',
      flipped: false,
      isBeingDragged: false,
    },
    'card-42': {
      id: 'card-42',
      front: 'Vibrant',
      back: 'Subtle',
      flipped: false,
      isBeingDragged: false,
    },
    'card-43': {
      id: 'card-43',
      front: 'Wide-eyed',
      back: 'Sophisticated',
      flipped: false,
      isBeingDragged: false,
    },
    'card-44': {
      id: 'card-44',
      front: 'Clever',
      back: 'Sincere',
      flipped: false,
      isBeingDragged: false,
    },
    'card-45': {
      id: 'card-45',
      front: 'Optimistic',
      back: 'Pessimistic',
      flipped: false,
      isBeingDragged: false,
    },
    'card-46': {
      id: 'card-46',
      front: 'Intuitive',
      back: 'Technical',
      flipped: false,
      isBeingDragged: false,
    },
    'card-47': {
      id: 'card-47',
      front: 'Secure',
      back: 'Free',
      flipped: false,
      isBeingDragged: false,
    },
    'card-48': {
      id: 'card-48',
      front: 'Graceful',
      back: 'Rugged',
      flipped: false,
      isBeingDragged: false,
    },
    'card-49': {
      id: 'card-49',
      front: 'Rigorous',
      back: 'Effortless',
      flipped: false,
      isBeingDragged: false,
    },
    'card-50': {
      id: 'card-50',
      front: 'Budding',
      back: 'Accomplished',
      flipped: false,
      isBeingDragged: false,
    },
  },
  columns: {
    start: {
      id: 'start',
      title: 'Start Here',
      cardIds: [
        'card-1',
        'card-2',
        'card-3',
        'card-4',
        'card-5',
        'card-6',
        'card-7',
        'card-8',
        'card-9',
        'card-10',
        'card-11',
        'card-12',
        'card-13',
        'card-14',
        'card-15',
        'card-16',
        'card-17',
        'card-18',
        'card-19',
        'card-20',
        'card-21',
        'card-22',
        'card-23',
        'card-24',
        'card-25',
        'card-26',
        'card-27',
        'card-28',
        'card-29',
        'card-30',
        'card-31',
        'card-32',
        'card-33',
        'card-34',
        'card-35',
        'card-36',
        'card-37',
        'card-38',
        'card-39',
        'card-40',
        'card-41',
        'card-42',
        'card-43',
        'card-44',
        'card-45',
        'card-46',
        'card-47',
        'card-48',
        'card-49',
        'card-50',
      ],
    },
    'you-are': {
      id: 'you-are',
      title: 'You are.',
      cardIds: [],
    },
    'you-are-not': {
      id: 'you-are-not',
      title: 'You are not.',
      cardIds: [],
    },
    torn: {
      id: 'torn',
      title: 'You are torn.',
      cardIds: [],
    },
    'does-not-apply': {
      id: 'does-not-apply',
      title: 'Does not apply.',
      cardIds: [],
    },
  },
  columnOrder: ['start', 'you-are', 'you-are-not', 'torn', 'does-not-apply'],
  lastLogin: 1,
  cardBeingDragged: false,
  ownerEmail: null,
}

export default appData
